import * as React from "react";
type Props = {
  className?: string,
};
function SvgGroundBeef({ className }: Props) {
  return (
    <svg
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-GroundBeef"
      className={className}
    >
      <path
        d="M44.111 29.9794C43.9459 29.5323 43.7287 29.0685 43.4413 28.5834C43.0304 27.6892 42.6035 26.6323 41.7764 25.708C41.0266 24.8703 39.8821 24.2713 38.8644 23.4267C38.7973 23.3682 38.7242 23.3098 38.6561 23.2512C37.7664 22.4598 37.0186 21.3759 35.9473 20.604C34.9435 19.879 33.6381 19.5047 32.5046 18.8037C31.4382 18.1447 30.5265 17.1419 29.363 16.52C28.1978 15.899 26.8555 15.6978 25.7132 15.1794C25.7123 15.1789 25.7115 15.1784 25.7105 15.1781C24.4972 14.6258 23.4619 13.7521 22.3004 13.3209C21.0565 12.8583 19.7304 12.8404 18.5739 12.5367C18.4953 12.5149 18.4139 12.4887 18.336 12.4676C17.061 12.0914 15.9236 11.4711 14.8037 11.312C13.5717 11.1378 12.4505 11.3702 11.4743 11.5233C10.9125 11.553 10.4067 11.6288 9.94322 11.7382C8.78139 11.9339 7.85085 12.2566 7.44043 13.0175C7.30416 13.2703 7.24275 13.545 7.23507 13.8367C6.66359 14.8962 5.62768 16.8175 5.30432 17.4154C3.463 20.8315 10.1673 27.9734 20.2781 33.3686C30.389 38.7653 40.077 40.371 41.9185 36.9567C42.2419 36.3589 43.2778 34.4363 43.8491 33.3764C44.0889 33.2088 44.2843 33.0063 44.4206 32.7537C44.8297 31.9942 44.5874 31.047 44.111 29.9794Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.6478 27.365L33.7014 29.703"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.2257 22.9807L26.3499 27.0922"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.6321 19.9487L19.7346 22.908"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1074 18.1189L17.7141 15.8639"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.4203 32.7536C43.8972 33.7232 42.5349 33.9844 40.9168 34.1723C39.8255 34.2993 38.518 34.6655 37.0569 34.4591C35.8906 34.2932 34.7075 33.6182 33.3656 33.2494C32.1913 32.9274 30.8316 32.9222 29.5602 32.4502C28.3984 32.0187 27.3626 31.1435 26.1485 30.5921C25.0068 30.0725 23.6631 29.8721 22.4978 29.2502C21.3341 28.629 20.4235 27.6258 19.3578 26.9669C18.224 26.2654 16.9174 25.8922 15.9125 25.167C14.815 24.3756 14.0589 23.2508 13.1396 22.4558C12.0879 21.5471 10.8685 20.9383 10.0842 20.0631C9.10229 18.9656 8.685 17.6784 8.18742 16.7026C7.45152 15.2591 6.91779 13.9869 7.44 13.0173C7.96318 12.0477 9.32541 11.7866 10.9435 11.5977C12.035 11.4716 13.3424 11.1054 14.8034 11.3118C15.9707 11.4777 17.153 12.1509 18.4949 12.5197C19.6692 12.8435 21.0287 12.8479 22.3001 13.3207C23.4621 13.7522 24.4979 14.6265 25.7118 15.1788C26.8543 15.6976 28.1972 15.8988 29.3627 16.5199C30.5264 17.1419 31.4368 18.1441 32.5035 18.8032C33.6372 19.5046 34.9429 19.8787 35.9471 20.6039C37.0454 21.3953 37.8016 22.5193 38.7217 23.3151C39.7726 24.2239 40.9918 24.8318 41.7762 25.7078C42.7582 26.8053 43.1763 28.0925 43.6731 29.0684C44.4088 30.5118 44.9427 31.784 44.4203 32.7536Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgGroundBeef;
